<div class="auto-scroll-container" #textContainer>
  <div class="scroll-text" #scrollText>
    <span>{{ ncText }}</span>
  </div>
</div>
